import React from "react";

export function SectionShell({ index, title, subtitle, children, testId }) {
  return (
    <section className="bg-white border border-gray-200 rounded p-5 lg:p-7" data-testid={testId}>
      <div className="flex items-center gap-3 mb-4">
        <div className="shrink-0 w-7 h-7 rounded-full bg-br-bronze text-white text-xs font-bold flex items-center justify-center">{index}</div>
        <div>
          <h2 className="font-display text-lg tracking-widest uppercase">{title}</h2>
          {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      <div className="divider-bronze mb-4" />
      <div className="space-y-3">{children}</div>
    </section>
  );
}

export function Field({ label, required, hint, children, className = "" }) {
  return (
    <div className={className}>
      <label className="label-br">{label}{required && <span className="text-br-bronze ml-0.5">*</span>}</label>
      {children}
      {hint && <div className="text-[11px] text-gray-500 mt-1">{hint}</div>}
    </div>
  );
}

export function CheckboxGroup({ options, value, onChange, columns = 2, testIdPrefix }) {
  const selected = Array.isArray(value) ? value : [];
  const cols = columns === 3 ? "sm:grid-cols-3" : "sm:grid-cols-2";
  return (
    <div className={`grid grid-cols-1 ${cols} gap-2`}>
      {options.map((opt) => {
        const isChecked = selected.includes(opt);
        return (
          <label
            key={opt}
            className={`flex items-center gap-2 px-3 py-2 rounded border cursor-pointer text-sm transition ${
              isChecked
                ? "bg-br-paper border-br-bronze"
                : "bg-white border-gray-200 hover:border-br-bronze"
            }`}
          >
            <input
              type="checkbox"
              className="accent-br-bronze"
              checked={isChecked}
              onChange={() => onChange(opt)}
              data-testid={testIdPrefix ? `${testIdPrefix}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}
            />
            <span>{opt}</span>
          </label>
        );
      })}
    </div>
  );
}

export function RadioGroup({ options, value, onChange, testIdPrefix }) {
  return (
    <div className="grid sm:grid-cols-3 gap-2">
      {options.map((opt) => {
        const isChecked = value === opt;
        return (
          <label
            key={opt}
            className={`flex items-center gap-2 px-3 py-2 rounded border cursor-pointer text-sm transition ${
              isChecked ? "bg-br-paper border-br-bronze" : "bg-white border-gray-200 hover:border-br-bronze"
            }`}
          >
            <input
              type="radio"
              className="accent-br-bronze"
              checked={isChecked}
              onChange={() => onChange(opt)}
              data-testid={testIdPrefix ? `${testIdPrefix}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}
            />
            <span>{opt}</span>
          </label>
        );
      })}
    </div>
  );
}
